import { useMutation } from '@apollo/client';
import { UpdateProjectDialogDocument } from './mutation.gql';
export const useUpdateProject = () => {
    const [mutate, state] = useMutation(UpdateProjectDialogDocument);
    const updateProject = (id, input) => mutate({ variables: { id, input } });
    return [updateProject, state];
};
